import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import RecoverValueFromSpentCoCatalyst from "./sections/RecoverValueFromSpentCoCatalyst";
import TheCatalystExperts from "./sections/TheCatalystExperts";
import OurFourStepMethodology from "./sections/OurFourStepMethodology";
import StrategicIndustrialAdvantages from "./sections/StrategicIndustrialAdvantages";
import CustomerServices from "./sections/CustomerServices";
import IndustrialInsights from "./sections/IndustrialInsights";
import RequestACoCatalystEvaluation from "./sections/RequestACoCatalystEvaluation";
import TransportServices from "./sections/TransportServices";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <RecoverValueFromSpentCoCatalyst />
      <TheCatalystExperts />
      <OurFourStepMethodology />
      <TransportServices />
      <StrategicIndustrialAdvantages />
      <CustomerServices />
      <IndustrialInsights />
      <RequestACoCatalystEvaluation />
      <Footer />
    </div>;
}